import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-best-match-card',
    templateUrl: './best-match-card.component.html',
    styleUrls: ['./best-match-card.component.scss']
})
export class BestMatchCardComponent implements OnInit {

    @Input() professor: any[];
    @Input() softskill: any[];

    constructor(
    ) { }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['professor']) {
            this.professor = changes['professor'].currentValue;
        }
        if (changes['softskill']) {
            this.softskill = changes['softskill'].currentValue;
        }
    }

    async ngOnInit() {
    }

}
